/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  dispatchMetaCapiTestEvent(inboxId) {
    return axios.post(`${this.url}/${inboxId}/dispatch_meta_capi_test_event`);
  }

  // OCULTAR CAIXA DE ENTRADA (so user id 1; guard no backend InboxPolicy#toggle_hidden?)
  toggleHidden(inboxId, hidden) {
    return axios.post(`${this.url}/${inboxId}/toggle_hidden`, { hidden });
  }

  // DESATIVAR CAIXA (menu Meta) — so id 1; esconde a caixa de Template/Disparo.
  toggleMetaDisabled(inboxId, metaDisabled) {
    return axios.post(`${this.url}/${inboxId}/toggle_meta_disabled`, {
      meta_disabled: metaDisabled,
    });
  }
}

export default new InboxHealthAPI();
